// Abre o WhatsApp na mesma aba pouco depois do envio. A espera dá tempo
// para o GTM disparar a conversão e para o lead ler a tela de sucesso.
// Na mesma aba o navegador não bloqueia como pop-up.
import { useEffect } from "react";

const REDIRECT_DELAY_MS = 1500;

export const useWhatsAppRedirect = (url: string | null) => {
  useEffect(() => {
    if (!url) return;
    const timer = window.setTimeout(() => {
      window.location.href = url;
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [url]);
};
